import { initialState } from "./state"

export default {
  setTerm: (state, payload) => (state.term = payload),
  setTermName: (state, payload) => (state.term.title = payload),
  setTermText: (state, payload) => (state.term.content = payload),
  setTermVersion: (state, payload) => (state.term.version = payload),
  setDateSchedule: (state, payload) => (state.scheduled_at = payload),
  setIsEditing: (state, payload) => (state.isEditing = payload),
  setActivateTermInEdit: (state, payload) =>
    (state.activateTermInEdit = payload),
  resetTerm: state => {
    const INITIAL_STATE = initialState()
    Object.keys(INITIAL_STATE).forEach(key => {
      state[key] = INITIAL_STATE[key]
    })
  }
}
